import { Component, OnInit, Input, DoCheck, Output, EventEmitter } from '@angular/core';
import { FORM_STYLE_CONFIG } from '../../d-form/style.config';
import { DTable, STRING, DateFilter, TextFilter, SelectFilter } from '../../types';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { STATE } from 'projects/training-partner/src/app/training-partner/constants';

@Component({
	selector: 'app-add-sector-target',
	templateUrl: './add-sector-target.component.html',
	styleUrls: ['./add-sector-target.component.css']
})
export class AddSectorTargetComponent implements OnInit, DoCheck {
	FORM_STYLE_CONFIG = FORM_STYLE_CONFIG;
	MODAL_ID = {
		ADD_SECTOR_TARGET: 'addSectorTarget'
	};
	STATE = STATE;
	@Input() selectedSchemeId;
	@Input() disable = false;
	@Input() state = this.STATE.VIEWING;
	// @Input() selectedSchemeId = '60';
	@Input() selectedSectorTargets = [];
	@Output() selectedSectorTargetsChange = new EventEmitter();
	@Output() validChange = new EventEmitter();
	@Input() trainingCentreName: string;
	constructor() { }
	sectorTargetTable: DTable;
	selectedCourses: any = [];
	sectorTargets = [];
	sectorTrainingTargetData = [];
	sectorTargetLength = 0;

	ngDoCheck() {
		if (this.sectorTargetLength !== this.selectedSectorTargets.length) {
			this.formatInputData();
		}
	}

	private formatInputData() {
		if (this.selectedSectorTargets && this.selectedSectorTargets.length) {
			// this.selectedSectorTargets = [];
			Helpers.emptyArray(this.sectorTargets);
			// this.sectorTargets = [];
			this.sectorTrainingTargetData = [];
			this.validChange.emit(true);
			this.selectedSectorTargets.map(sectorTarget => {
				this.sectorTrainingTargetData.push(sectorTarget);
				this.sectorTargets.push(
					this.formatSectorTargetForView(sectorTarget)
				);
			});
			this.syncTargetData();
		}
	}

	ngOnInit() {
		this.formatInputData();
		this.sectorTargetTable = new DTable({
			headers: {
				sectorName: 'Sector Name',
				//   associatedSkillSectorName: 'Associated Skill Sector Name',
				associatedCourse: 'Associated Course',
				proposedTrainingTargets: 'Proposed Training Targets',
				action: 'Action'
			},
			data: this.sectorTargets,
			dynamicClasses: {
				action: (this.editingOrFilling ? 'fa fa-trash' : STRING.EMPTY)
			},
			onClick: {
				action: (this.editingOrFilling ? this.removeSectorTarget.bind(this) : '')
			},
			mixedFilters: [
				// new DateFilter({
				// 	label: 'Date',
				// 	name: 'date',
				// 	startDate: new Date(),
				// 	endDate: new Date(),
				// }),
				// new DateFilter({
				// 	label: 'Date',
				// 	name: 'date'
				// }),
				// new TextFilter({
				// 	label: 'Enter Name',
				// 	name: 'name',
				// }),
				// new SelectFilter({
				// 	label: 'Gender',
				// 	name: 'gender',
				// 	options: ['male', 'female']
				// })
			]
		});
	}

	get editingOrFilling() {
		return this.state === this.STATE.EDITING || this.state === this.STATE.FILLING;
	}
	openAddSectorForm() {
		Helpers.openModal(this.MODAL_ID.ADD_SECTOR_TARGET);
	}

	removeSectorTarget(target) {
		const index = this.sectorTargets.indexOf(target);
		if (index > -1) {
			this.sectorTargets.splice(index, 1);
			this.sectorTrainingTargetData.splice(index, 1);
			this.sectorTargetLength = this.sectorTargets.length;
			this.selectedSectorTargetsChange.emit(this.sectorTrainingTargetData);
			this.syncTargetData();
		}
	}

	private formatSectorTargetForView(sectorTarget) {
		return {
			id: Helpers.randomId(),
			sectorName: sectorTarget.sector && sectorTarget.sector.name,
			associatedCourse: sectorTarget.course && sectorTarget.course.course,
			proposedTrainingTargets: sectorTarget.target,
			action: []
		};
	}

	private syncTargetData() {
		this.sectorTargetTable.data = this.sectorTargets;
		this.sectorTargetLength = this.selectedSectorTargets.length;
		this.selectedSectorTargetsChange.emit(this.sectorTrainingTargetData);
		this.selectedCourses = this.sectorTrainingTargetData.map(sectorTarget => sectorTarget.course);
	}

	addSectorTarget(sectorTarget) {
		Helpers.closeModal(this.MODAL_ID.ADD_SECTOR_TARGET);
		this.sectorTrainingTargetData.push(sectorTarget);
		this.sectorTargets.push(
			this.formatSectorTargetForView(sectorTarget)
		);
		this.validChange.emit(true);
		this.syncTargetData();
	}

}
